// Import model
import { OtgWoodCatalogStyleCondition } from '../models/OtgWoodCatalogStyleCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgWoodCatalogStyleIndexedFields } from '../models/OtgWoodCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgWoodCatalogStyleIndexedFieldsSerializer } from './OtgWoodCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgWoodCatalogStyleCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgWoodCatalogStyleConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgWoodCatalogStyleCondition instance
   */
  static deserialize(json: string): OtgWoodCatalogStyleCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgWoodCatalogStyleCondition instance
   */
  static fromObject(obj: any): OtgWoodCatalogStyleCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgWoodCatalogStyleCondition');
    }


    const instance: OtgWoodCatalogStyleCondition = {
      fieldName: obj['fieldName'] as OtgWoodCatalogStyleIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgWoodCatalogStyleCondition instances
   */
  static deserializeArray(json: string): OtgWoodCatalogStyleCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgWoodCatalogStyleCondition instance to a JSON string
   */
  static serialize(instance: OtgWoodCatalogStyleCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgWoodCatalogStyleCondition instance to a plain object
   */
  static toObject(instance: OtgWoodCatalogStyleCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgWoodCatalogStyleCondition instances to a JSON string
   */
  static serializeArray(instances: OtgWoodCatalogStyleCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
